import { TlfContextProps } from "./interface";

/**
 * Triggers discarding deferred ARS hierarchy updates and clears the delayed flag.
 *
 * @param state - Current TLF context state.
 * @returns Updated state with the discard trigger incremented.
 */
export const tlf_discardArsUpdates = (state: TlfContextProps): TlfContextProps => {
  const newState = { ...state };

  newState.discardDelayedHierarchyUpdatesTrigger = state.discardDelayedHierarchyUpdatesTrigger + 1;
  newState.delayedHierarchyUpdates = false;

  return newState;
};
